(ns manage.spec.adset
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [phrase.alpha :as p]))

(spec/def ::name
  (spec/and string?
            (complement str/blank?)
            #(<= (count %) 150)))

(p/defphraser (complement str/blank?)
  {:via [::name]}
  [_ problem]
  {:message "The adset name cannot be blank"
   :in (:in problem)
   :problem problem})

(p/defphraser #(<= (count %) max-size)
  {:via [::name]}
  [_ problem max-size]
  {:message (str "The adset name cannot be longer than " max-size " characters")
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  {:via [::name]}
  [_ problem key]
  {:message "The adset name has to be a string"
   :in (:in problem)
   :problem problem})
